import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Contact from "./pages/Contact";

import DashboardLayout from "./dashboard/DashboardLayout";
import DashboardHome from "./dashboard/DashboardHome";
import RCPSList from "./PrintedList/RCPSList";
import AddMoney from "./Payment/AddMoney";
 import DLPdfList from "./DLServices/DLPdfList";
import DLPdf from "./DLServices/DLPdf";
import DLServices from "./DLServices/DLServices";
import RCServices from "./Services/RCServices";
import RCParticulars from "./Services/RCParticulars";
import RCPdf from "./Services/RCPdf";
import RCPdf2 from "./Services/RCPdf2";
import RCPdfList from "./Services/RCPdfList";
import RcToMobile from "./Services/RcToMobile";
import PrintedList from "./PrintedList/PrintedList";
import PANServices from "./PANServices/PANServices";
import AadharToPan from "./PANServices/AadharToPan";
import PanVerify from "./PANServices/PanVerify";
import PanAdvance from "./PANServices/PanAdvance";
import AddRupee from "./Payment/AddRupee";
import RCBasic from "./Services/RCBasic";
import ChassisToRC from "./Services/ChassisToRC";
import PUCApply from "./Services/PUCApply";
import TwoWheelerPUC from "./Services/TwoWheelerPUC";

// ⭐ Admin
import UserManagement from "./admin/UserManagement";
import MobileServices from "./Mobile/MobileServices";
import MobileAdvanced from "./Mobile/MobileAdvanced";
import MobileList from "./Mobile/MobileList";
import RCPro from "./Services/RCPro";
import RCADVANCE from "./Services/RCADVANCE";
import RCList from "./Services/RCList";
import RcFather from "./Services/RcToFather";
import RCPDF3 from "./Services/RCPDF3";

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/contact" element={<Contact />} />

        {/* Dashboard */}
        <Route path="/dashboard" element={<DashboardLayout />}>

          {/* Default Dashboard Home */}
          <Route index element={<DashboardHome />} />

          {/* Wallet */}
          <Route path="add-money" element={<AddMoney />} />
          <Route path="add-rupee" element={<AddRupee />} />   {/* ⭐ NEW */}

          {/* RC Services */}
          <Route path="rc-services" element={<RCServices />} />
          <Route path="rcdetails" element={<RCParticulars />} />
          
          {/* ⭐ RC TO MOBILE */}
          <Route path="RctoMobile" element={<RcToMobile />} />

          {/* ⭐ RC PDF System */}
          <Route path="rcpdf" element={<RCPdf />} />
           <Route path="rcpdf2" element={<RCPdf2 />} />
           <Route path="rcpdf3" element={<RCPDF3 />} />
          <Route path="rcpdflist" element={<RCPdfList />} />
          <Route path="rcdetailslist" element={<RCPSList />} />
          <Route path="rcbasic" element={<RCBasic />} />
           <Route path="rcfather" element={<RcFather />} />
          <Route path="chassis-to-rc" element={<ChassisToRC />} />
          <Route path="puc-apply" element={<PUCApply />} />
          <Route path="puc-apply-2w" element={<TwoWheelerPUC />} />
           <Route path="rcpro" element={<RCPro />} />
              <Route path="rcadvance" element={<RCADVANCE />} />
                  <Route path="rccc" element={<RCList />} />

          <Route path="mob-services" element={<MobileServices />} />
          <Route path="mobile-basic" element={<MobileAdvanced />} />
          <Route path="mobilelist" element={<MobileList />} />
          

{/* ⭐ DL PDF System */}
           <Route path="dl-services" element={<DLServices />} />
           <Route path="dlpdflist" element={<DLPdfList />} />
           <Route path="dlpdf" element={<DLPdf />} />
           

<Route path="pan-services" element={<PANServices />} />
  <Route path="aadhar-to-pan" element={<AadharToPan />} />
  <Route path="pan-verify" element={<PanVerify />} />
  <Route path="pan-advance" element={<PanAdvance />} />




<Route path="printed-list" element={<PrintedList />} />


          {/* ⭐ Admin Routes */}
          <Route path="usermanagement" element={<UserManagement />} />

        </Route>

      </Routes>
    </BrowserRouter>
  );
}

export default App;
